import type { ApiReportData } from '../resident-report-detail/map-report-detail';

export interface ManagerReportRow extends ApiReportData {
  id: number;
  createdAt: string;
  reportYear: string;
  residentId: number;
  residentName: string;
  status: string | null;
  isSign: boolean | null;
}

export interface ManagerReportsFilter {
  clusterId?: string;
  statusId?: string;
  year?: string;
}

export interface ManagerReportsClusterOption {
  id: string;
  name: string;
}

export interface ManagerReportStatusOption {
  id: string;
  name: string;
  code: string;
}

export interface ManagerReportsListData {
  items: ManagerReportRow[];
  clusters: ManagerReportsClusterOption[];
}

export type ManagerReportSignCheckResult = {
  verify: boolean;
  fio: string;
  nameOrganization: string;
  certNumber: string;
  certAuthority: string;
  dateSign: string;
  dateEndSert: string;
};

export const MANAGER_REPORTS_PAGE_SIZE = 10;

export const MANAGER_REPORT_STATUS_OPTIONS: ManagerReportStatusOption[] = [
  { id: 'new', name: 'На рассмотрении', code: 'new' },
  { id: 'accepted', name: 'Принят', code: 'accepted' },
  { id: 'revision', name: 'Требует доработки', code: 'revision' },
  { id: 'draft', name: 'Черновик', code: 'draft' },
];

export function getManagerReportYearOptions(): Array<{ value: string; label: string }> {
  const currentYear = new Date().getFullYear();

  return Array.from({ length: 3 }, (_, index) => {
    const year = currentYear - 1 + index;

    return {
      value: String(year),
      label: `${year} г.`,
    };
  });
}
